<script lang="ts">
	import ClientZoneNavBar from "@components/ClientZoneNavBar.svelte";
	import Loader from "@components/Loader.svelte";
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import { Auth } from "@utils/Auth.svelte.js";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { ComponentProps, Snippet } from "svelte";
	import { AuthenticationModalKind } from "@core/schema/AuthenticationModalKind.js";
	import type { Customer } from "@core/schema/Customer.js";
	import translations from "./ClientZoneLayout.translations.json" with { type: "json" };
	import Layout from "./Layout.svelte";

	const translate = getTranslate(translations);
	const { children, ...props }: Omit<ComponentProps<typeof Layout>, "children"> & { children: Snippet<[Customer]> } =
		$props();

	$effect(() => {
		if (!Auth.signedIn && Auth.loaded) {
			Auth.openAuthenticationModal(AuthenticationModalKind.SignIn, {});
		}
	});

	const customer = $derived(Auth.loggedCustomer);
</script>

<Layout {...props}>
	{#if customer}
		<ClientZoneNavBar />
		{@render children(customer)}
		<div class="h-14 sm:h-18 md:h-22 lg:h-16 xl:h-30"></div>
	{:else if Auth.loaded}
		<div class="flex flex-col items-center gap-8 text-center my-24 justify-self-center">
			<Heading class="heading-2" level={1} text={translate("notSignedIn")} />
			<p>
				<Formatted text={translate("cannotDisplay")} />
			</p>
			<Button
				onclick={(): void => {
					Auth.openAuthenticationModal(AuthenticationModalKind.SignIn, {});
				}}
				variant={ButtonVariant.Dark}
				size={ButtonSize.Medium}
			>
				<Formatted text={translate("signIn")} />
			</Button>
		</div>
	{:else}
		<Loader />
	{/if}
</Layout>
